import React, { useContext, useState } from 'react';
import { withTheme, ThemeContext } from 'styled-components';
import { Row, Col } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSadTear, faSpinner } from '@fortawesome/free-solid-svg-icons';

import { Modal, Button } from '@cloudez/cloudez-design-system';
import {
  Header,
  Icon,
  Text,
  Title,
  Subtitle,
  Content,
  Footer,
} from 'components/ListingModal/styles';
import SurveyRenderer from 'components/SurveyRenderer';

const ChurnModal = ({ action, show, setShow, survey, partnerCanChurn }) => {
  const [loading, setLoading] = useState(false);
  const [payload, setPayload] = useState({});
  const theme = useContext(ThemeContext);

  const submit = e => {
    e.preventDefault();
    setLoading(true);
    action(payload);
  };

  return (
    <Modal show={show} setShow={setShow} noExit={loading}>
      <Header>
        <Icon>
          <FontAwesomeIcon icon={faSadTear} size="2x" />
        </Icon>
        <Text>
          {partnerCanChurn ? (
            <>
              <Title>Excluir revenda</Title>
              <Subtitle>Tem certeza que deseja deletar sua revenda?</Subtitle>
            </>
          ) : (
            <>
              <Title>Excluir cloud</Title>
              <Subtitle>Deseja remover este cloud?</Subtitle>
            </>
          )}
        </Text>
      </Header>

      <Content>
        <Row>
          <Col xs="12">
            {partnerCanChurn ? (
              <p
                style={{
                  color: theme.interface5,
                  fontSize: '15px',
                  textAlign: 'center',
                  margin: '10px auto',
                }}
              >
                Para deletar sua revenda, acesse o painel de Parceiros.
              </p>
            ) : (
              <form id="survey" onSubmit={submit}>
                <SurveyRenderer
                  survey={survey}
                  payload={payload}
                  setPayload={setPayload}
                />
              </form>
            )}
          </Col>
        </Row>
      </Content>
      <Footer>
        {partnerCanChurn ? (
          <Button
            disabled={loading}
            outline
            onClick={() => window.open('https://partners.cloudez.io/company')}
          >
            Partners
          </Button>
        ) : (
          <Button disabled={loading} type="submit" form="survey" icon error>
            {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : 'Remover'}
          </Button>
        )}
      </Footer>
    </Modal>
  );
};

export default withTheme(ChurnModal);
